import type { ConfigurationParameters } from 'api-client';
import { Configuration } from 'api-client';

import { getApiBaseUrl } from '@/lib/config';
import { getCSRFToken } from '@/lib/django';

export function getApiConfiguration(): Configuration {
  // using credentials: 'include' to allow cookies to be sent to the server
  // which also uses the session to handle authentication
  const params: ConfigurationParameters = {
    basePath: getApiBaseUrl(),
    credentials: 'include',
    headers: {
      'X-CSRFToken': getCSRFToken() || '',
    },
  };
  return new Configuration(params);
}
